import { styled } from 'styled-components';

export const SelectionGroup = styled.g`
    fill: none;
    stroke: coral;
    stroke-width: 3px;
`;
